const data = [
	{
		id: 1,
		searchKey: "",
		jobTitle: "Client Support Analyst",
		experience: 1, //in years values[from 1 to 5]
		salary: 1, //laks per year value[from 1 to 5.5]
		location: "Delhi", //first letter capital
		keySkills: [
			"client servicing",
			"kyc",
			"client services",
			"international bpo",
			"client onboarding",
			"document verification",
		],
		jobdetail: [
			"Client Support Analyst with experience of 1 to 3 yrs",
			"Notice: immediate to 7 days",
			"Max CTC Offered: 3.5LPA - 4LPA",
			"Only Delhi NCR candidates",
			"Rotational Shifts",
		],
		aboutCompany: [
			"Quess Corp (Magna Infotech)",
			"magna",
			"shradha.bhatnagar@quesscorp.com",
		],
		date: "Jul 17, 2021",
	},
	{
		id: 2,
		searchKey: "",
		jobTitle: "Mechanical Engineer",
		experience: 2,
		salary: 3,
		location: "Delhi",
		keySkills: [
			"gas",
			"kyc",
			"pumps",
			"maintenance planing",
			"options",
			"project engineering",
			"cost control",
			"cv",
			"mechanical system",
			"regulatory requirements",
			"reviews",
			"onshore",
			"offshore",
			"planing",
			"design",
			"codes",
			"endineering support",
			"testing",
			"supplier",
		],
		jobdetail: [
			"Provides technical and engineering support and guidance to offshore or on site teams",
			" Monitors the performance of the mechanical systems",
			"  Ensures that mechanical systems meet statutory and regulatory requirements",
			"Undertakes in-depth analyses/studies of problems and identifies longer-term solutions and/or options",
			" Undertakes general Project Engineering studies and activities",
		],
		aboutCompany: [
			"PR consultants Hiring For PR consultants",
			"Hiring For Agent",
			"chrisday4110@gmail.com",
		],
		date: "Feb 1 2021",
	},
	{
		id: 3,
		searchKey: "",
		jobTitle: "Looking for Diploma B.tech mechanical Engineer",
		experience: 3,
		salary: 6,
		location: "Delhi",
		keySkills: [
			"Mechanical",
			"testing",
			"production",
			"auto ancillary",
			"automobile",
			"qulity control",
			"cost control",
			"issues",
			"mechanical/production",
			"regulatory requirements",
		],
		jobdetail: [
			"Dear Sir/Mam,",
			"We are looking for Diploma mechanical Engineer freshers",
			"The Job description is given below.",
			"Qualification:-Diploma mechanical Engineer freshers I.T.I all trade",
			"Salary:- 10500 to 15000/-",
			"Designation:- Production",
		],
		aboutCompany: [
			"ERA Consultancy",
			"Era consultancy is providing job in only Automobile sector.",
			"career.sony15@gmail.com",
		],
		date: "Jul 23, 2021",
	},
	{
		id: 4,
		searchKey: "",
		jobTitle: "Looking for Diploma B.tech mechanical Engineer",
		experience: 2,
		salary: 1,
		location: "Delhi",
		keySkills: [
			"Mechanical",
			"testing",
			"production",
			"auto ancillary",
			"automobile",
			"qulity control",
			"cost control",
			"issues",
			"mechanical/production",
			"regulatory requirements",
		],
		jobdetail: [
			"Dear Sir/Mam,",
			"We are looking for Diploma mechanical Engineer freshers",
			"The Job description is given below.",
			"Qualification:-Diploma mechanical Engineer freshers I.T.I all trade",
			"Salary:- 10500 to 15000/-",
			"Designation:- Production",
		],
		aboutCompany: [
			"ERA Consultancy",
			"Era consultancy is providing job in only Automobile sector.",
			"career.sony15@gmail.com",
		],
		date: "Mar 9, 2021",
	},
	{
		id: 5,
		searchKey: "",
		jobTitle: "Telesales / Telemarketing Executive for Loans (HL-BL-LAP)",
		experience: 3,
		salary: 4,
		location: "Delhi",
		keySkills: [
			"telesales",
			"sales",
			"mortgage",
			"telecalling",
			"mortgage sales",
			"mortgage",
			"lead generation",
		],
		jobdetail: [
			"Dear All ",
			"We have an opening for the Telesales / Telemarketing Executive for Loans (HL-BL-LAP)",
			"Location: Pusa Road, New Delhi ",
			"CTC: Depends on candidate experience & last salary ",
			"Salary:- 10500 to 15000/-",
			"Designation:- Production",
		],
		aboutCompany: [
			"SMC Global Securities Ltd",
			"SMC Group, founded in 1990, is India's leading share and stock broker",
			" provides a wide range of financial services and investment solutions",
			"kanikas@smcinvestments.co.in",
		],
		date: "Jul 1, 2021",
	},
	{
		id: 6,
		searchKey: "",
		jobTitle:
			"Corporate Finance (Debt Syndication & Project Finance) - Asst. Vice President",
		experience: 5,
		salary: 8,
		location: "Delhi",
		keySkills: [
			"corporate lending",
			"secured financing",
			"project finance",
			"project financing",
			"project funding",
			"restructuring",
			"debt syndication",
			"term loan",
			"corparate finance",
		],
		jobdetail: [
			"Dear Sir/Mam,",
			"Greetings!!!",
			"Should ensure successful completion of the assignment within Should have effective co-ordination with clients and Banks, FIs, NBFCs.",
			"Should have excellent knowledge of preparation and review of financial.",
			"Should have worked closely with banks, FIs, NBFCs.",
		],
		aboutCompany: [
			"ERA Consultancy",
			"Era consultancy is providing job in only Automobile sector.",
			"career.sony15@gmail.com",
		],
		date: "Mar 29, 2021",
	},
	{
		id: 7,
		searchKey: "",
		jobTitle: "Kyc Analyst",
		experience: 3,
		salary: 4.0,
		location: "Delhi",
		keySkills: [
			"hiring",
			"aml",
			"learning managment",
			"kyc",
			"training needs analysis",
			"behavioral training",
			"kyc",
			"documentation",
			"due diligence",
			"career development",
			"new hire orientations",
			"new hire orientations",
			"customer relations",
			"training delivery",
		],
		jobdetail: [
			"Hiring for KY3P Process for Gurgaon Location,",
			"Job Location: Gurgaon",
			"Notice: immediate to 7 days",
		],
		aboutCompany: [
			"Quess Corp (Magna Infotech)",
			"magna",
			"shradha.bhatnagar@quesscorp.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 8,
		searchKey: "",
		jobTitle: "Front Office Receptionist",
		experience: 1,
		salary: 3,
		location: "Bangalore",
		keySkills: [
			"front offiece",
			"data entry",
			"administration work",
			"front office receptionist",
			"telecaller",
		],
		jobdetail: [
			"Profile:- We are hiring a Receptionist ( Only female Candidates)",
			"Ctc :- upto 2Lpa (Monthly 18k)",
			"Education Qualification:- any",
			"Work Type:- Permanent",
			"Location:- Noida sector 62",
		],
		aboutCompany: [
			"vibgyor enterprises Hiring For Vibgyor Enterpises",
			"magna",
			"varsha12tiwari@gmail.com",
		],
		date: "Jun 25, 2021",
	},
	{
		id: 9,
		searchKey: "",
		jobTitle:
			"Spot Offer Latter - Corporate Sales - High C.T.C - High Incentives - All Mumbai",
		experience: 0,
		salary: 7,
		location: "Bangalore",
		keySkills: [
			"lead generation",
			"hni sales",
			"direct sales",
			"financial planning",
			"channel partners",
			"direct channel sales",
			"cold calling",
			"general insurance",
			"casa sales",
			"coroprate sales",
			"life insurance",
			"field sales",
			"outside sales",
			"relationship managment",
			"irda",
			"business development",
			"cross selling",
		],
		jobdetail: [
			"Greetings from Reliance !!!!",
			"Urgent Hiring for Senior Relationship Manager - Immediate Joining- SPOT OFFER!!!",
			"Designation: Relationship Manager/Executive Relationship Manager",
			"Work Type:- Permanent",
			"Location:-Rajajinagar bangalore",
		],
		aboutCompany: [
			"RELIANCE NIPPON LIFE INSURANCE COMPANY LIMITED",
			"magna",
			"9043225@rcap.co.in",
		],
		date: "Jul 11, 2021",
	},
	{
		id: 10,
		searchKey: "",
		jobTitle: "Mechanical Engineer",
		experience: 0,
		salary: 1,
		location: "Bangalore",
		keySkills: [
			"polymer chemistry",
			"safety",
			"sensors",
			"inspection",
			"surfactants",
			"design",
			"rhelogy",
			"thin films",
			"construction",
			"testing",
			"resin",
			"commissioning",
			"mechanical",
			"design control",
			"emulsions",
			"polymer science",
			"research",
		],
		jobdetail: [
			"Mechanical engineeringis the study, design, development, construction, and testing ofmechanicaland thermal sensors and devices, including tools, engines, and machines.",
			"Department- Production maintenance",
			"Indusrty- oil & gas/Petroleum",
			"Work Type:- Permanent",
			"Location:-Penya bangalore",
		],
		aboutCompany: [
			"IPLACE HUMAN RESOURCES Hiring For VENIRO",
			"Hiring For Agent",
			"employment@veniro.ca",
		],
		date: "Jul 11, 2021",
	},
	{
		id: 11,
		searchKey: "",
		jobTitle: "Data Entry Operator",
		experience: 0,
		salary: 5,
		location: "Bangalore",
		keySkills: [
			"telesales",
			"sales",
			"mortgage",
			"telecalling",
			"mortgage sales",
			"mortgage",
			"lead generation",
		],
		jobdetail: [
			"Data Entry Operator responsibilities include:",
			"Job brief",
			"We are looking for a Data Entry Operator to update and maintain information on our company databases and computer systems.",
			"If you need information, you can contact on this number:- +919891621398",
		],
		aboutCompany: [
			"Ashutosh Bisht Hiring For Ashutosh bisht",
			"Hiring For Agent",
			"hr.ashutoshbisht@gmail.com",
		],
		date: "Jul 15, 2021",
	},
	{
		id: 12,
		searchKey: "",
		jobTitle: "Data Entry Operator",
		experience: 1,
		salary: 8,
		location: "Bangalore",
		keySkills: [
			"telesales",
			"sales",
			"mortgage",
			"telecalling",
			"mortgage sales",
			"mortgage",
			"lead generation",
		],
		jobdetail: [
			"Data Entry Operator responsibilities include:",
			"Job brief",
			"We are looking for a Data Entry Operator to update and maintain information on our company databases and computer systems.",
			"If you need information, you can contact on this number:- +919891621398",
		],
		aboutCompany: [
			"Ashutosh Bisht Hiring For Ashutosh bisht",
			"Hiring For Agent",
			"hr.ashutoshbisht@gmail.com",
		],
		date: "Jul 15, 2021",
	},
	{
		id: 13,
		searchKey: "",
		jobTitle: "Looking for Diploma B.tech mechanical Engineer",
		experience: 3,
		salary: 2,
		location: "Bangalore",
		keySkills: [
			"Mechanical",
			"testing",
			"production",
			"auto ancillary",
			"automobile",
			"qulity control",
			"cost control",
			"issues",
			"mechanical/production",
			"regulatory requirements",
		],
		jobdetail: [
			"Dear Sir/Mam,",
			"We are looking for Diploma mechanical Engineer freshers",
			"The Job description is given below.",
			"Qualification:-Diploma mechanical Engineer freshers I.T.I all trade",
			"Salary:- 10500 to 15000/-",
			"Designation:- Production",
		],
		aboutCompany: [
			"ERA Consultancy",
			"Era consultancy is providing job in only Automobile sector.",
			"career.sony15@gmail.com",
		],
		date: "Mar 9, 2021",
	},
	{
		id: 14,
		searchKey: "",
		jobTitle: "Telesales / Telemarketing Executive for Loans (HL-BL-LAP)",
		experience: 4,
		salary: 3,
		location: "Bangalore",
		keySkills: [
			"telesales",
			"sales",
			"mortgage",
			"telecalling",
			"mortgage sales",
			"mortgage",
			"lead generation",
		],
		jobdetail: [
			"Dear All ",
			"We have an opening for the Telesales / Telemarketing Executive for Loans (HL-BL-LAP)",
			"Location: Pusa Road, New Delhi ",
			"CTC: Depends on candidate experience & last salary ",
			"Salary:- 10500 to 15000/-",
			"Designation:- Production",
		],
		aboutCompany: [
			"SMC Global Securities Ltd",
			"SMC Group, founded in 1990, is India's leading share and stock broker",
			" provides a wide range of financial services and investment solutions",
			"kanikas@smcinvestments.co.in",
		],
		date: "Jul 1, 2021",
	},
	{
		id: 15,
		searchKey: "",
		jobTitle:
			"Corporate Finance (Debt Syndication & Project Finance) - Asst. Vice President",
		experience: 0,
		salary: 6,
		location: "Bangalore",
		keySkills: [
			"corporate lending",
			"secured financing",
			"project finance",
			"project financing",
			"project funding",
			"restructuring",
			"debt syndication",
			"term loan",
			"corparate finance",
		],
		jobdetail: [
			"Dear Sir/Mam,",
			"Greetings!!!",
			"Should ensure successful completion of the assignment within Should have effective co-ordination with clients and Banks, FIs, NBFCs.",
			"Should have excellent knowledge of preparation and review of financial.",
			"Should have worked closely with banks, FIs, NBFCs.",
		],
		aboutCompany: [
			"ERA Consultancy",
			"Era consultancy is providing job in only Automobile sector.",
			"career.sony15@gmail.com",
		],
		date: "Mar 29, 2021",
	},
	{
		id: 16,
		searchKey: "",
		jobTitle: "Bangalore",
		experience: 5,
		salary: 1,
		location: "Delhi",
		keySkills: [
			"hiring",
			"aml",
			"learning managment",
			"kyc",
			"training needs analysis",
			"behavioral training",
			"kyc",
			"documentation",
			"due diligence",
			"career development",
			"new hire orientations",
			"new hire orientations",
			"customer relations",
			"training delivery",
		],
		jobdetail: [
			"Hiring for KY3P Process for Gurgaon Location,",
			"Job Location: Gurgaon",
			"Notice: immediate to 7 days",
		],
		aboutCompany: [
			"Quess Corp (Magna Infotech)",
			"magna",
			"shradha.bhatnagar@quesscorp.com",
		],
		date: "Jun 27, 2021",
	},
	{
		id: 17,
		searchKey: "java",
		jobTitle: "JAVA / J2EE Developer",
		experience: 2,
		salary: 4,
		location: "Banglore",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Strong in Core Java ",
			" Strong Java Collection Framework ",
			"Good Knowledge of J2EE Development ",
		],
		aboutCompany: [
			"Exito Systems",
			"Exito Systems",
			"crawlerjobs+exitosystemscrawl@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 18,
		searchKey: "java",
		jobTitle: "Java/J2EE Developer (JD/BIG/N)",
		experience: 1,
		salary: 10,
		location: "Delhi",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Strong in Core Java ",
			" Strong Java Collection Framework ",
			"Good Knowledge of J2EE Development ",
		],
		aboutCompany: [
			"Times Business Solutions",
			"Times Business Solutions",
			"crawlerjobs+tbslcrawl@gmail.com",
		],
		date: "Jun 19, 2021",
	},
	{
		id: 19,
		searchKey: "java",
		jobTitle: "Java/ J2EE Developer - Engineer II",
		experience: 2,
		salary: 3,
		location: "Bangalore",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Build, deploy, and support modules of large, world-class enterprise-level solutions",
			"Use diagrams and tools to write programs, investigate and fix bugs, and install solutions.",
			"Good Knowledge of J2EE Development ",
			"Continually learn new technologies in related areas.",
		],
		aboutCompany: [
			"FICO",
			"FICO, originally Fair, Isaac and Company, is a data analytics company based in San Jose, California focused on credit scoring services. It was founded by Bill Fair and Earl Isaac in 1956. Its FICO score, a measure of consumer credit risk, has become a fixture of consumer lending in the United States.",
			"crawlerjobs+FICO@gmail.com",
		],
		date: "Jun 19, 2021",
	},
	{
		id: 20,
		searchKey: "java",
		jobTitle: "Java/ J2EE Developer - Engineer II",
		experience: 4,
		salary: 5,
		location: "Delhi",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Build, deploy, and support modules of large, world-class enterprise-level solutions",
			"Use diagrams and tools to write programs, investigate and fix bugs, and install solutions.",
			"Good Knowledge of J2EE Development ",
			"Continually learn new technologies in related areas.",
		],
		aboutCompany: [
			"FICO",
			"FICO, originally Fair, Isaac and Company, is a data analytics company based in San Jose, California focused on credit scoring services. It was founded by Bill Fair and Earl Isaac in 1956. Its FICO score, a measure of consumer credit risk, has become a fixture of consumer lending in the United States.",
			"crawlerjobs+FICO@gmail.com",
		],
		date: "Jun 19, 2021",
	},
	{
		id: 21,
		searchKey: "java",
		jobTitle: "Java/J2ee Developer in telecom domain (Sr. Positions)",
		experience: 5,
		salary: 6,
		location: "Bangalore",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Build, deploy, and support modules of large, world-class enterprise-level solutions",
			"Use diagrams and tools to write programs, investigate and fix bugs, and install solutions.",
			"Good Knowledge of J2EE Development ",
			"Continually learn new technologies in related areas.",
		],
		aboutCompany: [
			"Brainstorm Technologies",
			"Brainstorm Technologies",
			"crawlerjobs+brainstormindia@gmail.com",
		],
		date: "Jun 19, 2021",
	},
	{
		id: 22,
		searchKey: "java",
		jobTitle: "Java/J2ee Developer in telecom domain (Sr. Positions)",
		experience: 0,
		salary: 1,
		location: "Delhi",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Build, deploy, and support modules of large, world-class enterprise-level solutions",
			"Use diagrams and tools to write programs, investigate and fix bugs, and install solutions.",
			"Good Knowledge of J2EE Development ",
			"Continually learn new technologies in related areas.",
		],
		aboutCompany: [
			"Brainstorm Technologies",
			"Brainstorm Technologies",
			"crawlerjobs+brainstormindia@gmail.com",
		],
		date: "Jul 21, 2021",
	},
	{
		id: 23,
		searchKey: "java",
		jobTitle: "Java/J2EE Developer (JD/BIG/N)",
		experience: 1,
		salary: 5,
		location: "Delhi",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Strong in Core Java ",
			" Strong Java Collection Framework ",
			"Good Knowledge of J2EE Development ",
		],
		aboutCompany: [
			"Times Business Solutions",
			"Times Business Solutions",
			"crawlerjobs+tbslcrawl@gmail.com",
		],
		date: "Jun 19, 2021",
	},
	{
		id: 23,
		searchKey: "java",
		jobTitle: "Java/J2EE Developer (JD/BIG/N)",
		experience: 2,
		salary: 7,
		location: "Bangalore",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Strong in Core Java ",
			" Strong Java Collection Framework ",
			"Good Knowledge of J2EE Development ",
		],
		aboutCompany: [
			"Times Business Solutions",
			"Times Business Solutions",
			"crawlerjobs+tbslcrawl@gmail.com",
		],
		date: "Jun 19, 2021",
	},
	{
		id: 24,
		searchKey: "java",
		jobTitle: "JAVA / J2EE Developer",
		experience: 3,
		salary: 2,
		location: "Delhi",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Strong in Core Java ",
			" Strong Java Collection Framework ",
			"Good Knowledge of J2EE Development ",
		],
		aboutCompany: [
			"Exito Systems",
			"Exito Systems",
			"crawlerjobs+exitosystemscrawl@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 25,
		searchKey: "java",
		jobTitle: "Java/ J2EE Developer - Engineer II",
		experience: 4,
		salary: 8,
		location: "Delhi",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Build, deploy, and support modules of large, world-class enterprise-level solutions",
			"Use diagrams and tools to write programs, investigate and fix bugs, and install solutions.",
			"Good Knowledge of J2EE Development ",
			"Continually learn new technologies in related areas.",
		],
		aboutCompany: [
			"FICO",
			"FICO, originally Fair, Isaac and Company, is a data analytics company based in San Jose, California focused on credit scoring services. It was founded by Bill Fair and Earl Isaac in 1956. Its FICO score, a measure of consumer credit risk, has become a fixture of consumer lending in the United States.",
			"crawlerjobs+FICO@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 26,
		searchKey: "java",
		jobTitle: "Java/J2ee Developer in telecom domain (Sr. Positions)",
		experience: 5,
		salary: 5,
		location: "Bangalore",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Build, deploy, and support modules of large, world-class enterprise-level solutions",
			"Use diagrams and tools to write programs, investigate and fix bugs, and install solutions.",
			"Good Knowledge of J2EE Development ",
			"Continually learn new technologies in related areas.",
		],
		aboutCompany: [
			"Brainstorm Technologies",
			"Brainstorm Technologies",
			"crawlerjobs+brainstormindia@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 26,
		searchKey: "java",
		jobTitle: "Java/J2ee Developer in telecom domain (Sr. Positions)",
		experience: 0,
		salary: 1,
		location: "Delhi",
		keySkills: [
			"core java",
			"sql queries",
			"collection framework",
			"sql",
			"bar",
			"java",
			"j2ee",
			"oracle",
			"salary",
			"grails",
			"groovy",
			"linux",
		],
		jobdetail: [
			"Bellow skill is required:  ",
			"Build, deploy, and support modules of large, world-class enterprise-level solutions",
			"Use diagrams and tools to write programs, investigate and fix bugs, and install solutions.",
			"Good Knowledge of J2EE Development ",
			"Continually learn new technologies in related areas.",
		],
		aboutCompany: [
			"Brainstorm Technologies",
			"Brainstorm Technologies",
			"crawlerjobs+brainstormindia@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 27,
		searchKey: "php",
		jobTitle: "Php Developer (Work from home)",
		experience: 1,
		salary: 9,
		location: "Delhi",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Job Description ",
			"Design, estimate, and code new features.",
			"Architect new applications, and expand existing ones.",
			"Define, document, and enforce engineering standards",
			"Perform code reviews of your team members work.",
		],
		aboutCompany: [
			"Highpoints Technologies India Pvt Ltd",
			"Highpoints Technologies India Pvt Ltd",
			"SindhuP@ehighpoints.net",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 28,
		searchKey: "php",
		jobTitle: "Php Developer (Work from home)",
		experience: 2,
		salary: 3,
		location: "Bangalore",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Job Description ",
			"Design, estimate, and code new features.",
			"Architect new applications, and expand existing ones.",
			"Define, document, and enforce engineering standards",
			"Perform code reviews of your team members work.",
		],
		aboutCompany: [
			"Highpoints Technologies India Pvt Ltd",
			"Highpoints Technologies India Pvt Ltd",
			"SindhuP@ehighpoints.net",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 29,
		searchKey: "php",
		jobTitle: "Full stack PHP developer",
		experience: 3,
		salary: 2,
		location: "Delhi",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Requirements  ",
			" Min. 4+ Years Experience in Opencart or similar e - commerce platforms such as Zencart, Magento etc.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"Akra Tech",
			"Akra Tech",
			"crawlerjobs+akratechcrawl@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 30,
		searchKey: "php",
		jobTitle: "Full stack PHP developer",
		experience: 4,
		salary: 8,
		location: "Bangalore",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Requirements  ",
			" Min. 4+ Years Experience in Opencart or similar e - commerce platforms such as Zencart, Magento etc.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"Akra Tech",
			"Akra Tech",
			"crawlerjobs+akratechcrawl@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 31,
		searchKey: "php",
		jobTitle: "WordPress Developer PHP",
		experience: 5,
		salary: 4,
		location: "Delhi",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Requirements  ",
			" Min. 4+ Years Experience in Opencart or similar e - commerce platforms such as Zencart, Magento etc.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"PHP Scripts Mall Pvt Ltd",
			"PHP Scripts Mall Pvt Ltd",
			"crawlerjobs+phpscriptsmallcrawl@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 32,
		searchKey: "php",
		jobTitle: "WordPress Developer PHP",
		experience: 0,
		salary: 1,
		location: "Bangalore",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Requirements  ",
			" Min. 4+ Years Experience in Opencart or similar e - commerce platforms such as Zencart, Magento etc.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"PHP Scripts Mall Pvt Ltd",
			"PHP Scripts Mall Pvt Ltd",
			"crawlerjobs+phpscriptsmallcrawl@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 33,
		searchKey: "php",
		jobTitle: "PHP Developer",
		experience: 1,
		salary: 6,
		location: "Delhi",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Requirements  ",
			" Min. 4+ Years Experience in Opencart or similar e - commerce platforms such as Zencart, Magento etc.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 34,
		searchKey: "php",
		jobTitle: "Web Developer - PHP",
		experience: 2,
		salary: 3,
		location: "Hyderabad",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Requirements  ",
			" Min. 4+ Years Experience in Opencart or similar e - commerce platforms such as Zencart, Magento etc.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"Brain Technosys Pvt. Ltd",
			"Brain Technosys Pvt. Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 35,
		searchKey: "php",
		jobTitle: "Web Developer - PHP",
		experience: 3,
		salary: 2,
		location: "Delhi",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Requirements  ",
			" Min. 4+ Years Experience in Opencart or similar e - commerce platforms such as Zencart, Magento etc.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"Brain Technosys Pvt. Ltd",
			"Brain Technosys Pvt. Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 36,
		searchKey: "php",
		jobTitle: "PHP Developer",
		experience: 4,
		salary: 4,
		location: "Pune",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 37,
		searchKey: "php",
		jobTitle: "PHP Developer",
		experience: 5,
		salary: 7,
		location: "Mumbai",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 38,
		searchKey: "php",
		jobTitle: "Developer(PHP)",
		experience: 0,
		salary: 1,
		location: "Bangalore",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 38,
		searchKey: "php",
		jobTitle: "Developer(PHP)",
		experience: 1,
		salary: 4,
		location: "Mumbai",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 39,
		searchKey: "java",
		jobTitle: "Java Web Developer",
		experience: 2,
		salary: 9,
		location: "Mumbai",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 40,
		searchKey: "java",
		jobTitle: "Java Web Developer",
		experience: 3,
		salary: 2,
		location: "Chennai",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 41,
		searchKey: "java",
		jobTitle: "Web Developer-JAVA",
		experience: 4,
		salary: 4,
		location: "Bangalore",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
	{
		id: 42,
		searchKey: "java",
		jobTitle: "Web Developer-JAVA",
		experience: 5,
		salary: 9,
		location: "Noida",
		keySkills: [
			"front end",
			"sprint planning",
			"sql quries",
			"sql",
			"object-oriented programing",
			"mysql",
			"html",
			"redis",
			"computer science",
			"zend",
			"jquery",
			"project management",
		],
		jobdetail: [
			"Web Developer - PHP DESCRIPTION Develop object oriented web applications using PHP. ",
			"Work in a fast pace, high pressure environment. Create back- end code and reusable objects in php.",
			"Vast experience in developing custom modules / applications in PHP ",
			"Worked on end to end , Front - end and Back - end development of PHP Applications ",
			" Experience in backend development using AWS RDS, S3 with MySQL database.",
			"Hands - on experience in deploying PHP applications on AWS EC2, Beanstalk.",
		],
		aboutCompany: [
			"New Media Guru India Pvt Ltd",
			"New Media Guru India Pvt Ltd",
			"crawlerjobs+newmediaguru@gmail.com",
		],
		date: "Jun 20, 2021",
	},
];

export { data };
